// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CreateApcBase, CreateApcBaseSchema } from 'api/gen/CreateApcBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Decimal52, Decimal52Schema } from 'api/gen/Decimal52';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Decimal80, Decimal80Schema } from 'api/gen/Decimal80';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { MilkKg, MilkKgSchema } from 'api/gen/MilkKg';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { StableCode, StableCodeSchema } from 'api/gen/StableCode';

const requiredPart = t.interface({
  correctionType: t.literal('UPDATE'),
  fatPercentage: t.union([Decimal52Schema, t.null]),
  lactosePercentage: t.union([Decimal52Schema, t.null]),
  milkKg: MilkKgSchema,
  proteinPercentage: t.union([Decimal52Schema, t.null]),
  somaticCells: t.union([Decimal80Schema, t.null]),
  stableCode: StableCodeSchema,
  urea: t.union([Decimal52Schema, t.null]),
});

export const CreateApcUpdateSchema = excess(t.intersection([CreateApcBaseSchema.type, requiredPart]));

export interface CreateApcUpdate extends t.TypeOf<typeof CreateApcUpdateSchema> {}
